<template lang="pug">
  .b-page
    TheHeader(
      :showBurgerOnMd="!showLeftMenuOnMd"
      :burgerOpened="leftMenuOpened"
      @burgerClick="toggleMenu"
      )
      slot(name="header")
    ._overlay(:class="{ show: leftMenuOpened }" @click="overlayClick")
    main._main
      MenuLeft(v-if="!wide && !noLeftMenu" :opened="leftMenuOpened")
      ._container(:class="{ wide }")
        AccountBlockedNotifier
        MenuTop(:items="topMenuItems" v-if="!noTopMenu")
        ErrorPage(v-if="error" :code="error.status")
        slot(v-else)
    ._slot-footer.js-footer-edge
      ._footerbar-container.container(id="footer-bar")
        slot(name="footer")
    TheFooter
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import MenuLeft from '@/components/MenuLeft.vue';
import MenuTop from '@/components/MenuTop.vue';
import ErrorPage from '@/components/ErrorPage.vue';
import AccountBlockedNotifier from '@/components/app/AccountBlockedNotifier.vue';

export default {
  name: 'Default',
  components: { TheHeader, TheFooter, MenuLeft, MenuTop, ErrorPage, AccountBlockedNotifier }, // eslint-disable-line
  props: {
    topMenuItems: Array,
    wide: Boolean,
    noTopMenu: Boolean,
    noLeftMenu: Boolean,
  },
  data() {
    return {
      leftMenuOpened: false,
    };
  },
  methods: {
    toggleMenu(open) {
      this.leftMenuOpened = open;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.body.style.overflow = open ? 'hidden' : 'auto';
    },
    overlayClick() {
      this.leftMenuOpened = false;
      document.body.style.overflow = 'auto';
    },
  },
  computed: {
    error() { return this.$store.getters['error/err403'] || this.$store.getters['error/err404']; },
    parentRoute() { return this.$route.matched.slice(-1)[0]?.parent; },
    showLeftMenuOnMd() {
      // todo remove
      return true; // this.$route.meta?.showLeftMenuOnMd ?? this.parentRoute?.meta?.showLeftMenuOnMd ?? false;
    },
  },
};
</script>

<style lang="scss">
.page {
  overflow-anchor: none;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  &__main {
    position: relative;
    padding-bottom: 60px;
    flex-grow: 2;
    display: flex;
  }

  &__header-content {
    max-width: var(--container-size);
    margin: 0 auto 0 390px;
    padding-left: var(--container-gutter);
    padding-right: var(--container-gutter);
  }

  &__container {
    min-height: 700px;
    flex-grow: 2;
    max-width: var(--container-size);
    margin: 0 auto;
    padding-left: var(--container-gutter);
    padding-right: var(--container-gutter);

    &.wide {  max-width: 90vw }
  }

  &__slot-footer {
    position: sticky;
    bottom: 0;
    background: rgba(30, 49, 71, 1);
    z-index: 1000;
  }

  &__footerbar-container {
    position: relative;
    padding: 0 45px !important;

    &:not(:empty):before {
      position: absolute;
      bottom: -1px;
      display: block;
      content: '';
      width: calc(100% - 45px * 2);
      height: 1px;
      background: #fff;
    }
  }

  &__footer-wrapper {
    width: 100%;
    //border-bottom: 1px solid rgba(223, 232, 255, 1);
  }

  &__overlay {
    opacity: 0;
    visibility: hidden;
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    transition: opacity 0.3s, visibility 0.3s;
    &.show {
      cursor: pointer;
      background-color: rgba(#000, 0.5);
      opacity: 1;
      z-index: 50;
      visibility: visible;
    }
  }

  @media (max-width: 2300px) {
    &__container {
      margin-right: 0;
      margin-left: 12vw;

      &.wide {
        margin-left: 0;

      }
    }
  }

  @media (max-width: 1700px) {
    &__main {
      display: grid;
      padding: 0 40px 40px;
      gap: 40px;
      grid-template-columns: 60px 60px repeat(10, 1fr);
    }

    &__container {
      min-height: 740px;
      margin: 0;
      padding: 0;
      max-width: none;
      grid-column: 3 / 10 span;

      &.wide {
        grid-column: 1 / 12 span;
        max-width: none;
      }
    }
  }

  @media (max-width: 1500px) {
    &__main {
      padding: 0 25px 25px;
      gap: 25px;
      //grid-template-columns: 30px 30px repeat(10, 1fr);
    }
  }

  @media (max-width: 1024px) {
    &__main {
      position: static;
      padding-left: 25px;
      padding-right: 25px;
      display: grid;
      gap: 20px;
      grid-template-columns: repeat(12,1fr);
    }

    &__container {
      grid-column: 11 span;
    }

    &__footerbar-container {
      padding: 0 25px !important;

      &:before {
        width: calc(100% - 25px * 2);
      }
    }
  }

  @media (max-width: 1024px) {
    &__container {
      grid-column: 12 span;
    }

    &__main {
      display: block;
    }
  }

  @media (max-width: 576px) {
    &__main {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}

</style>
